import {
  experimental_extendTheme as materialExtendTheme,
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from "@mui/material/styles";
import { extendTheme } from "@mui/joy";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/material/CssBaseline";

const materialTheme = materialExtendTheme();
import * as React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { PhoneCallButton } from "../../../phone/PhoneCallButton";

export default function ParentCard({ parent, student }) {
  const baseTheme = extendTheme();

  const darkOnlyTheme = extendTheme({
    cssVarPrefix: "sidebar_",
    colorSchemes: {
      light: baseTheme.colorSchemes.dark,
      dark: baseTheme.colorSchemes.dark,
    },
  });

  return (
    <MaterialCssVarsProvider theme={darkOnlyTheme}>
      <JoyCssVarsProvider>
        <CssBaseline enableColorScheme />
        <Box
          sx={{
            width: { xs: "100%", sm: "50%" },
            position: "relative",
            overflow: { xs: "auto", sm: "initial" },
            paddingTop: 1,
            paddingRight: 1,
          }}
        >
          <Card
            orientation="horizontal"
            sx={{
              borderColor: "rgba(48, 49, 48, 0.78)",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              width: "100%",
              height: "100%",
              flexWrap: "wrap",

              // make the card resizable for demo
            }}
          >
            <CardContent>
              <Typography
                sx={{ fontSize: "xl", fontWeight: "lg" }}
                textColor="rgba(255, 255, 255, 0.89)"
              >
                {parent?.fullname || "Name not on file"}
              </Typography>
              <Typography
                level="body-sm"
                textColor="rgba(229, 234, 238, 0.75)"
                sx={{ fontWeight: "lg" }}
              >
                Parent
              </Typography>
              <Sheet
                sx={{
                  bgcolor: "rgba(55, 59, 63, 0.3)",
                  borderRadius: "sm",
                  p: 1.5,
                  my: 1.5,
                  display: "flex",
                  gap: 2,
                  "& > div": { flex: 1 },
                }}
              >
                <div>
                  <Typography
                    level="body-xs"
                    sx={{ fontWeight: "lg" }}
                    textColor="rgb(161, 172, 183)"
                  >
                    Phone Number
                  </Typography>
                  <PhoneCallButton
                    phoneNumber={parent?.address1_telephone1}
                    parent={parent}
                    student={student}
                  />
                </div>

                <div>
                  <Typography
                    level="body-xs"
                    sx={{ fontWeight: "lg" }}
                    textColor="rgb(161, 172, 183)"
                  >
                    Email
                  </Typography>
                  <Typography textColor="white" sx={{ fontWeight: "lg" }}>
                    {parent?.emailaddress1 || "N/A"}
                  </Typography>
                </div>
              </Sheet>
            </CardContent>
          </Card>
        </Box>
      </JoyCssVarsProvider>
    </MaterialCssVarsProvider>
  );
}
